import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import LanguageIcon from "@mui/icons-material/Language";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../Context/LanguageContext";
import { useNavigate } from "react-router-dom";

const AdminHeader = ({
  sidebarOpen,
  drawerWidth = 220,
  collapsedWidth = 64,
  anchor = "left",
  onToggleSidebar,
  onLogout,
}) => {
  const currentWidth = sidebarOpen ? drawerWidth : collapsedWidth;
  const { t, i18n } = useTranslation();
  const { lang, toggleLanguage } = useLanguage();
  const navigate = useNavigate();

  const handleToggleLanguage = () => {
    let newLang = lang === "rn" ? "en" : lang === "ar" ? "en" : "ar";
    toggleLanguage();
    if (i18n && typeof i18n.changeLanguage === "function") {
      i18n.changeLanguage(newLang);
    }
    document.documentElement.lang = newLang;
    document.documentElement.dir = newLang.startsWith("ar") ? "rtl" : "ltr";
  };

  const handleLogout = async (e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    try {
      if (typeof onLogout === "function") {
        await onLogout();
      } else {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
      }
    } catch (err) {
      // ignore
    }
    navigate("/login");
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        width: `calc(100% - ${currentWidth}px)`,
        ...(anchor === "left"
          ? { ml: `${currentWidth}px` }
          : { mr: `${currentWidth}px` }),
        transition: "all 0.2s ease",
        height: 48,
        justifyContent: "center",
        backdropFilter: "blur(8px)",
      }}
    >
      <Toolbar
        variant="dense"
        sx={{ minHeight: 48, display: "flex", justifyContent: "space-between" }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Tooltip title={sidebarOpen ? "طي القائمة" : "فتح القائمة"}>
            <IconButton
              color="inherit"
              edge="start"
              onClick={onToggleSidebar}
              size="small"
            >
              <MenuIcon />
            </IconButton>
          </Tooltip>

          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700, letterSpacing: 0.5 }}
          >
            {t ? t("admin_panel", "لوحة تحكم الادمن") : "لوحة تحكم الادمن"}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Tooltip title="عرض الموقع في تبويب جديد">
            <Button
              component="a"
              href="/"
              target="_blank"
              rel="noopener"
              startIcon={<OpenInNewIcon sx={{ fontSize: 16 }} />}
              size="small"
              sx={{
                textTransform: "none",
                bgcolor: "rgba(255,255,255,0.12)",
                color: "#fff",
                borderRadius: 2,
                px: 1.5,
                fontSize: 13,
                "&:hover": { bgcolor: "rgba(255,255,255,0.24)" },
              }}
            >
              {t("عرض الموقع")}
            </Button>
          </Tooltip>

          <Tooltip title={lang === "ar" ? "Switch to English" : "التبديل للعربية"}>
            <Button
              onClick={handleToggleLanguage}
              startIcon={<LanguageIcon sx={{ fontSize: 16 }} />}
              size="small"
              sx={{
                textTransform: "none",
                bgcolor: "rgba(255,255,255,0.12)",
                color: "#fff",
                borderRadius: 2,
                px: 1.5,
                fontSize: 13,
                "&:hover": { bgcolor: "rgba(255,255,255,0.24)" },
              }}
            >
              {lang === "ar" ? "EN" : "عربي"}
            </Button>
          </Tooltip>

          <Tooltip title="تسجيل خروج">
            <Button
              onClick={handleLogout}
              startIcon={<LogoutIcon sx={{ fontSize: 16 }} />}
              size="small"
              sx={{
                textTransform: "none",
                bgcolor: "rgba(211,47,47,0.85)",
                color: "#fff",
                borderRadius: 2,
                px: 1.5,
                fontSize: 13,
                "&:hover": { bgcolor: "#d32f2f" },
              }}
            >
              {t("logout")}
            </Button>
          </Tooltip>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AdminHeader;